import ShopPrints from './ShopPrints';
import ShopPrintsContainer from './ShopPrints.container';

export default ShopPrintsContainer(ShopPrints);
